import React from 'react';
import useComponentVisible from '~/hooks/useComponentVisible';
import { useUser } from '~/providers/user';
import { formatTagsToHTML } from '~/utils/formatTaggedUsers';
import getDateFromISOToLocal from '~/utils/getDateFromISOToLocal';
import { useComment } from '../providers';
export const Comment = ({ comment }) => {
    var _a;
    const { taggableComparisonUsers } = useUser();
    const { deleteComment, deletingCommentId } = useComment();
    const { ref, isComponentVisible: isActionMenuVisible, setIsComponentVisible, } = useComponentVisible(false);
    const handleDeleteComment = (commentId) => {
        deleteComment(commentId);
    };
    const formatUsername = (name) => {
        if (name.includes('@')) {
            return name.split('@', 1)[0];
        }
        return name;
    };
    const isDeletingComment = deletingCommentId === comment.id;
    const privilegeGroupNames = (_a = comment.privilegeGroups) === null || _a === void 0 ? void 0 : _a.map(privilegeGroup => privilegeGroup.displayName).join(', ');
    return (React.createElement("div", { key: comment.createdAt, id: `comment-${comment.id}`, className: 'comment' },
        React.createElement("div", { className: 'title' },
            React.createElement("span", { className: 'author' },
                React.createElement("span", { className: 'name' }, formatUsername(comment.createdBy)),
                "\u2022",
                React.createElement("span", { className: 'time' }, getDateFromISOToLocal(comment.createdAt))),
            React.createElement("div", { className: 'right' },
                privilegeGroupNames && (React.createElement("div", { className: 'privilege-groups overflow-ellipsis', title: privilegeGroupNames },
                    React.createElement("div", { className: 'names overflow-ellipsis' }, privilegeGroupNames),
                    React.createElement("div", null,
                        React.createElement("i", { className: 'fas fa-lock icon' })))),
                !isDeletingComment &&
                    React.createElement("span", { className: 'action-dropdown', onClick: () => setIsComponentVisible(!isActionMenuVisible) },
                        React.createElement("i", { className: 'fas fa-ellipsis-v' }),
                        isActionMenuVisible && (React.createElement("div", { ref: ref, className: 'action-list' },
                            React.createElement("div", { className: 'action', onClick: () => handleDeleteComment(comment.id) },
                                React.createElement("i", { className: 'fas fa-trash' }),
                                "\u00A0 Delete Comment")))),
                isDeletingComment && React.createElement("span", null,
                    React.createElement("i", { className: 'fa fa-spinner fa-spin' })))),
        React.createElement("p", { dangerouslySetInnerHTML: {
                __html: formatTagsToHTML(comment.text, taggableComparisonUsers),
            } })));
};
